/**
 * @fileoverview DELETE handler for the "/companies/:company_id/app_group_permission_sets/delete_permission_set/:id" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { companiesCompanyIdAppGroupPermissionSetsDeletePermissionSetIdCacheKeys } from "./constants";
import type {
  DeleteCompaniesCompanyIdAppGroupPermissionSetsDeletePermissionSetIdProps,
  CompaniesCompanyIdAppGroupPermissionSetsDeletePermissionSetIdResult,
} from "./types";

export const deleteCompaniesCompanyIdAppGroupPermissionSetsDeletePermissionSetId = reactQueryMutationAdapter(
  companiesCompanyIdAppGroupPermissionSetsDeletePermissionSetIdCacheKeys,
  (
    props: DeleteCompaniesCompanyIdAppGroupPermissionSetsDeletePermissionSetIdProps
  ): Promise<CompaniesCompanyIdAppGroupPermissionSetsDeletePermissionSetIdResult> => {
    return fetch(
      `/companies/${encodeURIComponent(
        props.companyId
      )}/app_group_permission_sets/delete_permission_set/${encodeURIComponent(props.permissionSetId)}`,
      "DELETE",
      props
    );
  }
);
